import { render, staticRenderFns } from "./addSnapshotFee.vue?vue&type=template&id=5f5add68&scoped=true"
import script from "./addSnapshotFee.vue?vue&type=script&lang=js"
export * from "./addSnapshotFee.vue?vue&type=script&lang=js"
import style0 from "./addSnapshotFee.vue?vue&type=style&index=0&id=5f5add68&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f5add68",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/重构-快递前端-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5f5add68')) {
      api.createRecord('5f5add68', component.options)
    } else {
      api.reload('5f5add68', component.options)
    }
    module.hot.accept("./addSnapshotFee.vue?vue&type=template&id=5f5add68&scoped=true", function () {
      api.rerender('5f5add68', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/finance/receivableManagementSite/aRGenerationNew/cmp/addSnapshotFee.vue"
export default component.exports